<template>
  <InnerCardInfo
    v-if="valttikorttiData"
    :label="localStorage.translations.pages['setting-personal_area'].sections['valttikortti']"
    :data="[
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya'],
        value: dateEndFormatted || '-',
      },
    ]"
    :images="valttikorttiData.image ? [valttikorttiData.image] : null"
    need-image-domain
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot />
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'
export default {
  name: 'ValttikorttiPdf',
  props: { valttikortti: Object, editReady: Boolean },
  components: { InnerCardInfo },
  data: () => ({
    valttikorttiData: null,
    dateEnd: null,
    dateEndFormatted: null,
  }),
  watch: {
    valttikortti() {
      this.getData()
    },
    dateEnd(val) {
      this.dateEndFormatted = this.formatDate(this.dateEnd)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.valttikortti) {
        this.valttikorttiData = JSON.parse(this.valttikortti.data)
        this.dateEnd = this.valttikorttiData.date_end
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return (day ? day + '.' : '') + (month ? month + '.' : '') + year
    },
  },
}
</script>
